import React, { FC, useEffect, useState } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../../../constants/aampeTheme';
import ICONS from '../../../../../constants/icons';

interface ImageAlternatePreviewProps {
    text: string;
}

const ImageAlternatePreview: FC<
    React.PropsWithChildren<ImageAlternatePreviewProps>
> = ({ text }) => {
    const [isError, setIsError] = useState<boolean>(false);

    useEffect(() => setIsError(false), [text]);

    if (!text) return <ICONS.blankImage />;

    if (text && isError) return <ICONS.imageError />;

    return <AlternateImage src={text} onError={() => setIsError(true)} />;
};

const AlternateImage = styled.img({
    borderRadius: aampeTheme.borderRadius.default,
    height: 64,
    width: 64,
    objectFit: 'contain',
});

export default ImageAlternatePreview;
